import type { ExpenseCategory } from '@vuokramani/shared';

/**
 * Linkit Verohallinnon ohjeisiin. Yhdessä paikassa, jotta ne on helppo tarkistaa ja
 * päivittää, kun Verohallinto muuttaa sivujaan (tarkista vähintään kerran vuodessa).
 */
export const TAX_LINKS = {
  rentalIncome: 'https://www.vero.fi/henkiloasiakkaat/omaisuus/vuokratulot/',
  deductions: 'https://www.vero.fi/henkiloasiakkaat/omaisuus/vuokratulot/vahennykset/',
  renovations:
    'https://www.vero.fi/henkiloasiakkaat/omaisuus/vuokratulot/vahennykset/remonttikulut/',
  form7h:
    'https://vero.fi/tietoa-verohallinnosta/yhteystiedot-ja-asiointi/lomakkeet/tayttoohjeet/7h-vuokratulot--osakehuoneistot-t%C3%A4ytt%C3%B6ohje/',
} as const;

export const CATEGORY_LINK: Record<ExpenseCategory, string> = {
  maintenance_charge: TAX_LINKS.deductions,
  capital_charge: TAX_LINKS.deductions,
  water: TAX_LINKS.deductions,
  repair: TAX_LINKS.renovations,
  improvement: TAX_LINKS.renovations,
  furniture: TAX_LINKS.deductions,
  interest: TAX_LINKS.deductions,
  insurance: TAX_LINKS.deductions,
  other: TAX_LINKS.deductions,
};
